import axios from 'axios'
export const getDataByGlobalSearchParam = async (search, take) => {
    try {
        const response = await axios.get(
            `${process.env.API_URL}/global-search/v2?search=${search}&take=${take}`
        )
        if (response.data && !response.data.hasOwnProperty('network_devices')) {
            response.data.network_devices = []
        }
        return response.data
    } catch (error) {
        throw new Error(
            error.response ? error.response.data.message : 'Network error'
        )
    }
}
